/**
 * @generated SignedSource<<c0439bf85fbd2fd3f5b627a9c45055c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type CalendarSource = "google" | "internal" | "office365";
export type FilterMeetingOwnership = "ALL_MEETINGS" | "CUSTOM" | "ORGANIZED_BY_ME";
import { FragmentRefs } from "relay-runtime";
export type EventForm_viewer$data = {
  readonly account: {
    readonly name: string;
  };
  readonly autoRecordSettings: {
    readonly enabled: boolean;
    readonly meetingOwnershipFilter: FilterMeetingOwnership;
  } | null;
  readonly calendars: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly color: string | null;
        readonly hadErrorOnSync: boolean | null;
        readonly id: string;
        readonly lastSyncDatetime: string | null;
        readonly name: string | null;
        readonly source: CalendarSource;
        readonly sourcePrimary: boolean;
        readonly syncEnabled: boolean;
      };
    }>;
  };
  readonly remainingMeetingRecordingCredits: number;
  readonly user: {
    readonly firstName: string;
    readonly id: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"RecordingRowOutOfCreditsWarning_viewer" | "useConferencingOptions_viewer" | "useParticipantsOptions_viewer" | "usePreferredTimezone_viewer">;
  readonly " $fragmentType": "EventForm_viewer";
};
export type EventForm_viewer$key = {
  readonly " $data"?: EventForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventForm_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventForm_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "remainingMeetingRecordingCredits",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserAutoRecordSettings",
      "kind": "LinkedField",
      "name": "autoRecordSettings",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingOwnershipFilter",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CalendarConnection",
      "kind": "LinkedField",
      "name": "calendars",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CalendarEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Calendar",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "source",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sourcePrimary",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "syncEnabled",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "color",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastSyncDatetime",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hadErrorOnSync",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useConferencingOptions_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useParticipantsOptions_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePreferredTimezone_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecordingRowOutOfCreditsWarning_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "9be8e2c3a8c44562ebf9777803aacd51";

export default node;
